export default "__VITE_ASSET__D5WDJG5B__"